/**
 * LocalStorage implementation of the OIDC storage interface
 */
export class LocalStorageOIDC {
    keyPrefix;
    fields = {};
    constructor(keyPrefix = 'authiculate-sdk') {
        this.keyPrefix = keyPrefix;
    }
    deleteKey(key) {
        localStorage.removeItem(`${this.keyPrefix}:${key}`);
        this.fields[key] = null;
    }
    getKey(key, singleUse = true) {
        let value;
        const itemKey = `${this.keyPrefix}:${key}`;
        if (!this.fields[key] || typeof this.fields[key] !== 'string') {
            value = localStorage.getItem(itemKey);
        }
        else {
            value = this.fields[key];
        }
        if (singleUse && value) {
            this.deleteKey(key);
        }
        return value;
    }
    setKey(key, value) {
        this.fields[key] = value;
        localStorage.setItem(`${this.keyPrefix}:${key}`, value);
    }
    clear() {
        this.clearAuthorizationData();
        this.clearTokens();
    }
    clearAuthorizationData() {
        this.deleteKey('code_verifier');
        this.deleteKey('nonce');
    }
    clearTokens() {
        this.deleteKey('access_token');
        this.deleteKey('access_token_payload');
        this.deleteKey('id_token');
        this.deleteKey('id_token_payload');
        this.deleteKey('refresh_token');
    }
    getAccessToken() {
        return this.getKey('access_token', false);
    }
    getAccessTokenPayload() {
        const payload = this.getKey('access_token_payload', false);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return payload ? JSON.parse(payload) : null;
    }
    getCodeVerifier() {
        return this.getKey('code_verifier', false);
    }
    getIdToken() {
        return this.getKey('id_token', false);
    }
    getIdTokenPayload() {
        const payload = this.getKey('id_token_payload', false);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return
        return payload ? JSON.parse(payload) : null;
    }
    getNonce() {
        return this.getKey('nonce');
    }
    getRefreshToken() {
        return this.getKey('refresh_token');
    }
    setAccessToken(accessToken) {
        this.setKey('access_token', accessToken);
    }
    setAccessTokenPayload(payload) {
        this.setKey('access_token_payload', JSON.stringify(payload));
    }
    setCodeVerifier(codeVerifier) {
        this.setKey('code_verifier', codeVerifier);
    }
    setIdToken(idToken) {
        this.setKey('id_token', idToken);
    }
    setIdTokenPayload(payload) {
        this.setKey('id_token_payload', JSON.stringify(payload));
    }
    setNonce(nonce) {
        this.setKey('nonce', nonce);
    }
    setRefreshToken(refreshToken) {
        this.setKey('refresh_token', refreshToken);
    }
}
